import {Component, OnInit} from '@angular/core';
import {Library} from "../../../models/library.model";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {LibraryTagFilter} from "../../../constants/library-constants";
import {DEFAULT_LIBRARIES_ITEMS} from "../../../constants/reporting-constants";
import {LibraryService} from "../../../services/library.service";
import {CustomSnackBarService} from "../../../services/custom-snackbar.service";
import {AdminService} from "../../../services/admin.service";
import {BehaviorSubject} from "rxjs";
import {DialogService} from "../../../services/dialog.service";
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder} from "@angular/forms";
import {extractErrorMessage} from '../../../utils/error-utils';

@Component({
  selector: 'app-library-config',
  templateUrl: './library-config.component.html',
  styleUrls: ['./library-config.component.scss']
})
export class LibraryConfigComponent implements OnInit {
  public applyConfigurationButtonDisabled: boolean = true;
  public loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public libraries: Library[] = [];

  public libraryFormGroup = this.formBuilder.group({
    library: [null]
  });
  constructor(private libraryService: LibraryService,
              private adminService: AdminService,
              private dialogService: DialogService,
              private translate: TranslateService,
              private formBuilder: FormBuilder,
              private customSnackBarService: CustomSnackBarService) {
  }

  ngOnInit(): void {

    this.libraryFormGroup.get('library')?.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(searchTextValue => {
        if (searchTextValue) {
          if (typeof searchTextValue === 'string') {
            this.applyConfigurationButtonDisabled = true;

            if (searchTextValue.trim().length >= 3) {
              this.loadLibraries(searchTextValue);
              this.applyConfigurationButtonDisabled = true;
            }

          } else {
            this.applyConfigurationButtonDisabled = false;
          }

        } else {
          this.applyConfigurationButtonDisabled = true;
        }
      });
  }

  public applyFinraSettings(): void {
    this.applyConfigurationButtonDisabled = true;
    const settingsToApply = this.libraryFormGroup.getRawValue();
    this.adminService.configureFinraLibrary(settingsToApply.library.libraryId).subscribe({
      next: () => {
        this.customSnackBarService.openSuccessSnackbar(this.translate.instant('snackBarMessage.applyFinraSettingSnackbarMessage'));
        this.libraryFormGroup.reset();
        this.applyConfigurationButtonDisabled = true;
      }, error: (error) => {
        this.applyConfigurationButtonDisabled = false;
        this.loadingSubject.next(false);
        this.dialogService.complianceError(error.error.message);
      }
    });
  }

  loadLibraries(query: string): void {

    this.libraryService.searchLibraries(LibraryTagFilter.ALL, query, DEFAULT_LIBRARIES_ITEMS, '').subscribe({
      next: (resp) => this.libraries = resp.libraries
      , error: (error) => this.dialogService.error(extractErrorMessage(error))
    });
  }

  displayFn(library: Library): string {
    return library && library.libraryName ? library.libraryName : '';
  }


}
